import api from './api';

export interface Resultado {
  id: number;
  exame: string;
  data_realizacao: string | null;
  data_emissao: string | null;
  status: 'aprovado' | 'reprovado' | 'laudo_emitido' | 'pendente';
  medico: string | null;
  crm: string | null;
  clinica: string;
  observacoes: string | null;
  arquivo_url: string | null;
  path: string | null;
  valor: string | null;
  colaborador: {
    id: number;
    nome: string;
    cpf: string;
  };
}

export interface PaginationMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: PaginationMeta;
}

class ResultadosService {
  /**
   * Lista todos os resultados de exames da empresa
   */
  async getAllResultados(
    page: number = 1,
    limit: number = 10,
    search?: string,
  ): Promise<PaginatedResponse<Resultado>> {
    const response = await api.get<PaginatedResponse<Resultado>>(
      '/resultados',
      {
        params: {
          page,
          limit,
          search,
        },
      },
    );
    return response.data;
  }

  /**
   * Lista resultados de exames por colaborador
   */
  async getResultadosPorColaborador(
    colaboradorId: number,
  ): Promise<PaginatedResponse<Resultado>> {
    const response = await api.get<PaginatedResponse<Resultado>>(
      '/resultados',
      {
        params: {
          colaborador_id: colaboradorId,
        },
      },
    );
    return response.data;
  }

  /**
   * Busca resultado específico
   */
  async getResultado(resultadoId: number): Promise<Resultado> {
    const response = await api.get<Resultado>(
      `/resultados/${resultadoId}`,
    );
    return response.data;
  }

  /**
   * Download do arquivo do resultado
   * Retorna o Blob do arquivo para download
   */
  async downloadResultado(resultadoId: number): Promise<Blob> {
    const response = await api.get(
      `/resultados/${resultadoId}/download`,
      {
        responseType: 'blob',
        maxRedirects: 5,
      },
    );
    return response.data;
  }
}

export const resultadosService = new ResultadosService();

